var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { Card as RebassCard } from 'rebass';
import styled from '@emotion/styled';
import { compose, boxShadow, borderRadius } from 'styled-system';
var _Card = styled(RebassCard)(compose(borderRadius, boxShadow));
var Card = React.forwardRef(function (props, ref) {
    return React.createElement(_Card, __assign({ ref: ref }, props));
});
Card.defaultProps = {
    bg: 'neutral_0',
    borderRadius: 'normal',
    boxShadow: 'card',
    p: 3,
};
export default Card;
